// extracted by mini-css-extract-plugin
export default {"img":"BannerTableRow_img__am78R"};